/**
 *  getrealRouter 过滤权限 对比通过name来判断是否有权限
 * @param  {any} userRouter - 用户权限 后端获取
 * @param  {any} allRouter - 本地所有权限
 */
export function getrealRouter(userRouter:any, allRouter:any) {
    const realRoutes:any = [];
    allRouter.forEach((v:any) => {
        userRouter.forEach((item:any) => {
            if (!item.common) {
                // 非模版产品页面
                if (item.name && item.name === v.meta.name) {
                    if (item.children && item.children.length > 0) {
                        v.children = getrealRouter(item.children, v.children);
                    }
                    realRoutes.push(v);
                }
            }
        });
    });
    userRouter.forEach((item:any) => {
        if (item.common) {
            // 模版产品页面
            const active = {
                path: item.product,
                name: item.product,
                meta: { name: item.name, type: item.type },
                component: () => import(`@/views/${item.common}.vue`),
            };
            realRoutes.push(active);
        }
    });
    return realRoutes;
}

/**
 *  getSiderbar 通过路由获取当前侧边栏数据
 * @param  {any} allRouter - 删选权限后的路由
 * @param  {String} currentProduct  -  当前打开页面所属的产品类型
 */
export function getSiderbar(allRouter:any, currentProduct:String) {
    const realSider:any = [];
    allRouter.forEach((all:any) => {
        if (all.meta.type && all.meta.type === currentProduct) {
            if (all.children && all.children.length > 0) {
                all.children = getSiderbar(all.children, currentProduct);
            }
            realSider.push(all);
        }
    });
    return realSider;
}


/**
 * getUserProductList 过滤获取当前用户拥有的产品类型home
 * @param all  - 所有权限
 * @return - 权限列表
 */

export function getUserProductList(all:any) {
    const product: Array<any> = [];
    all.forEach((p:any) => {
        if (p.meta && p.meta.type && product.indexOf(p.meta.type) === -1) {
            product.push(p.meta.type);
        }
    });
    return product;
}
